/* eslint-disable */
import { produce } from "immer";
import {
  FC_MANAGED_INCOMECHART_FETCH_FAILURE,
  FC_MANAGED_INCOMECHART_FETCH_SUCCESS,
  FC_MANAGED_INCOMECHART_FETCH_START,
} from "../actions/types";

const futurecalculatorIncomechart = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case FC_MANAGED_INCOMECHART_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case FC_MANAGED_INCOMECHART_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case FC_MANAGED_INCOMECHART_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default futurecalculatorIncomechart;
